/**
 * Constants for the alert notification store.
 */
import type { AlertViewModel } from '../../api/adapters';

export const MAX_RECENT_ALERTS = 20;
export const MAX_TOASTS = 3;
export const TOAST_TTL_MS = 5_000;

/**
 * Why a toast is being held on screen (plan W4 step 13): a pointer over
 * it, keyboard focus inside it, or a finger on it. While ANY toast holds,
 * the whole stack holds still -- nothing expires and a new toast waits --
 * because a person reading one, or reaching for its "Show where", must not
 * have it vanish or move under them (`toast-stack.ts`). Every toast gets a
 * fresh `TOAST_TTL_MS` once the stack's last hold ends.
 */
export type ToastHold = 'hover' | 'focus' | 'touch';

export interface ToastItem {
  id: string;
  alert: AlertViewModel;
  expiresAt: number;
  /** The holds in force; absent or empty means the toast is expiring. */
  heldBy?: readonly ToastHold[];
}